import React from "react";
import Button from "./Button";

const SubmitFormButton = ({loading, text, disabled}) => {

    return <Button type='submit' text={text} loading={loading} disabled={disabled}/>

}

export default SubmitFormButton;